import { render, staticRenderFns } from "./ListInfoComponent.vue?vue&type=template&id=4b07e91a"
import script from "./ListInfoComponent.vue?vue&type=script&lang=js"
export * from "./ListInfoComponent.vue?vue&type=script&lang=js"
import style0 from "./ListInfoComponent.vue?vue&type=style&index=0&id=4b07e91a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports